<template>
  <div class="contact-page container">
    <form action="" method="POST" @submit.prevent="sendMessage">
      <div>
        <h3>Send us a Message</h3>
      </div>

      <div>
        <label for="">Name</label>
        <input
          v-model="name"
          placeholder="Full Name"
          required
          type="text"
          name="name"
        />
        <span class="error" v-if="errors.name">{{ errors.name[0] }}</span>
      </div>

      <div>
        <label for="">Email</label>
        <input
          v-model="email"
          placeholder="email@address.com"
          required
          type="text"
          name="email"
        />
        <span class="error" v-if="errors.email">{{ errors.email[0] }}</span>
      </div>

      <div>
        <label for="">Subject</label>
        <input
          v-model="subject"
          placeholder="Subject"
          required
          type="text"
          name="subject"
        />
        <span class="error" v-if="errors.subject">{{ errors.subject[0] }}</span>
      </div>

      <div>
        <label for="">Message</label>
        <editor
          style="background-color:white;"
          tinymce-script-src="/js/tinymce/tinymce.min.js"
          row="7"
          name="message"
          placeholder="Type your message here"
          v-model="message"
          :init="{
            branding: false,
            statusbar: false,
            menubar: false,
            plugins: [],
            toolbar: false
          }"
        />
        <span class="error" v-if="errors.message">{{ errors.message[0] }}</span>
      </div>

      <div>
        <button type="submit" :disabled="loading">Send Message</button>
      </div>

      <div class="loading" v-if="loading">
        <div class="load-spinner"></div>
      </div>

      <div class="success-message" v-if="showSuccessMessage">
        <p class="message">{{ successMessage }}</p>
        <button role="button" @click="showSuccessMessage = false">Close</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import editor from "@tinymce/tinymce-vue";

export default {
  name: "Contact",
  components: {
    editor
  },
  data() {
    return {
      name: "",
      email: "",
      subject: "",
      message: "",
      errors: [],
      loading: false,
      showSuccessMessage: false,
      successMessage: ""
    };
  },
  methods: {
    sendMessage() {
      this.loading = true;
      axios
        .post("/contact", {
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message
        })
        .then(response => {
          this.successMessage = response.data.message;
          this.showSuccessMessage = true;
          this.$store.commit("showAlert", null);
          this.name = "";
          this.email = "";
          this.subject = "";
          this.message = "";
          this.errors = [];
        })
        .catch(error => {
          this.errors = error.response.data.errors || [];
          this.$store.commit("showAlert", {
            status: "danger",
            message: error.response.data.message || "Failed"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
